import { Injectable } from '@angular/core';
import { OnFinish } from 'src/app/rokezzz/api/api/on-finish';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggedUser } from '../api/logged-user';
import { PasswordChange } from '../api/password-change';
import { RokezzzApiService } from '../../api/services/api.service';
import { RokezzzRecaptchaService } from 'src/app/rokezzz/recaptcha/services/recaptcha.service';
import { User } from '../api/user';
import { EmailUnique } from '../api/email-unique';
import { RokezzzNotificationService } from '../../notification/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzUserService {
    public readonly apiPath: string = 'users';

    private loggedUserSubject: BehaviorSubject<LoggedUser | null> = new BehaviorSubject<LoggedUser | null>(null);

    public constructor(
        protected readonly rokezzzApiService: RokezzzApiService,
        protected readonly rokezzzRecaptchaService: RokezzzRecaptchaService,
        protected readonly rokezzzNotificationService: RokezzzNotificationService,
    ) { }

    public getLoggedUser(): BehaviorSubject<LoggedUser | null> {
        return this.loggedUserSubject;
    }

    public clearLoggedUserCache(): void {
        this.loggedUserSubject.next(null);
    }

    public refreshLoggedUserCache(): void {
        this.rokezzzApiService.get(
            this.apiPath + '/static/loggedUser',
            {},
            (loggedUser: LoggedUser) => {
                this.loggedUserSubject.next(loggedUser);
            },
            () => {
                this.loggedUserSubject.next(null);
            }
        );
    }

    public isLoggedUser(loggedUser: LoggedUser | null): loggedUser is LoggedUser {
        return loggedUser !== null;
    }

    public getIRI(id: number): string {
        return this.rokezzzApiService.apiUrl + this.apiPath + '/' + id;
    }

    public changePassword(
        data: PasswordChange,
        onSuccess: OnFinish<void>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.patch(
            this.apiPath + '/changePassword',
            data,
            onSuccess,
            onError,
        );
    }

    public post(
        data: User,
        onSuccess: OnFinish<void>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzRecaptchaService.prepareTokenForAction(
            'postUser',
            () => {
                this.rokezzzApiService.post(
                    this.apiPath,
                    data,
                    onSuccess,
                    onError,
                );
            }
        );
    }

    public getById(
        id: number,
        onSuccess: OnFinish<User>,
        onError: OnFinish<HttpErrorResponse>,
    ): void {
        return this.rokezzzApiService.get(
            this.apiPath + '/' + id,
            {},
            onSuccess,
            onError
        );
    }

    public isEmailUnique(email: string): Observable<EmailUnique> {
        return this.rokezzzApiService.prepareGet(
            this.apiPath + '/static/isEmailUnique',
            { email },
        ) as Observable<EmailUnique>;
    }
}
